import React, { useMemo } from "react";

function sanitizeHtml(value) {
  if (!value) return "";
  const doc = new DOMParser().parseFromString(value, "text/html");
  doc.querySelectorAll("script, style, iframe, object, embed, link, meta").forEach((node) => node.remove());
  doc.querySelectorAll("*").forEach((node) => {
    [...node.attributes].forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const content = attribute.value.trim().toLowerCase();
      if (name.startsWith("on") || (name === "href" && content.startsWith("javascript:"))) node.removeAttribute(attribute.name);
    });
  });
  return doc.body.innerHTML;
}

export function RichText({ html, className = "" }) {
  const content = useMemo(() => sanitizeHtml(html), [html]);
  return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: content }} />;
}
